import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordCard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M4 16H3C1.89543 16 1 15.1046 1 14V4C1 2.89543 1.89543 2 3 2H17",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.99997 30L3.31464 25.8533C2.81156 25.3006 2.64445 24.52 2.87711 23.8098C3.10978 23.0995 3.70631 22.5691 4.43894 22.4211C5.17156 22.2731 5.92719 22.5304 6.41731 23.0947L8.99997 26V14C8.99997 12.8954 9.8954 12 11 12C12.1045 12 13 12.8954 13 14V23H15C18.3137 23 21 25.6863 21 29V30",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M19 9.5C19 8.67157 19.6716 8 20.5 8H29.5C30.3284 8 31 8.67157 31 9.5V16.5C31 17.3284 30.3284 18 29.5 18H20.5C19.6716 18 19 17.3284 19 16.5V9.5Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M25 2V2C22.7909 2 21 3.79086 21 6V8H29V6C29 3.79086 27.2091 2 25 2Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M25 12.5333C25.2761 12.5333 25.5 12.7572 25.5 13.0333C25.5 13.3095 25.2761 13.5333 25 13.5333C24.7239 13.5333 24.5 13.3095 24.5 13.0333C24.5 12.7572 24.7239 12.5333 25 12.5333",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgPasswordCard);
export default ForwardRef;
